import React from "react";
import Article from "../components/Article";
import "../styles/article.css";
import { firestore } from "../firebase";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";

import { useEffect, useState } from "react";

const YEARS = [2025, 2024, 2023, 2022];

function Mediji() {
  const [posts, setPosts] = useState([]);
  const [selectedYear, setSelectedYear] = useState(2025);

  const ref = collection(firestore, "mediji");

  async function getData() {
    const q = query(ref, where("visible", "==", true), orderBy("dateCreated", "desc"));

    const data = await getDocs(q);
    let arr = [];
    data.forEach((doc) => {
      // Extract the data of each document and store it in an object
      const documentData = doc.data();

      // Add the document object to the dataArray
      arr.push(documentData);
    });
    setPosts(arr);
    console.log(arr);
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <div className="article-section">
        <div className="title">Mediji o nama</div>
        <div className="divider"></div>
        <div className="year-bar">
          {YEARS.map((year) => (
            <span key={year} onClick={() => setSelectedYear(year)} className={`year-item ${year === selectedYear ? "active" : ""}`}>
              {year}
            </span>
          ))}
        </div>
        <div className="article-grid">
          {posts
            .filter((object) => object.year === selectedYear)
            .map((object, i) => (
              <Article title={object.title} link={object.link} imageUrl={object.image} key={i} />
            ))}
        </div>
      </div>
    </div>
  );
}

export default Mediji;
